import React, { useState } from 'react';
import styled from 'styled-components';
import { RichTextWithAnchor } from '../Typography/RichText';
import { CTALink } from '../Link';
import { isFieldValid } from '../../utils/validation';
import { Image } from '../Image';
import { VideoThumbnail, VideoLightbox } from '../../components/Video';
import media from '../../utils/media';
const ContentContainer = styled.div `
  display: flex;
  margin-bottom: ${({ adjustForMediaContent }) => (adjustForMediaContent ? '46px' : '40px')};
  padding: 0px 20px;

  ${media.mobile} {
    flex-direction: column-reverse;
    align-items: center;
    padding-top: 20px;
  }
`;
const TextContent = styled.div `
  flex: 1;
  max-width: ${({ adjustForMediaContent }) => (adjustForMediaContent ? '444px' : '985px')};
  width: 100%;
  margin-right: ${({ adjustForMediaContent }) => (adjustForMediaContent ? '31px' : '0px')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  ${media.mobile} {
    margin-right: 0px;
  }
`;
const RichTextContainer = styled.div `
  margin-bottom: 20px;
  width: 100%;
`;
const MediaContainer = styled.div `
  max-width: 50%;
  height: 100%;
  flex: 1;

  ${media.mobile} {
    max-width: fit-content;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 24.29px;
  }
`;
const ThumbnailContainer = styled.div `
  height: 321px;
  max-width: 510px;
  width: 100%;

  ${media.smallTablet} {
    max-height: 321px;
  }

  ${media.mobile} {
    width: 100%;
    height: 166.71px;
  }
`;
export const FAQContent = ({ answerText, ctaLink, ctaLinkText, thumbnailImage, video, allowContentToBeTabbable }) => {
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const onPlay = () => setIsVideoOpen(true);
    const hasMediaContent = isFieldValid(thumbnailImage, 'src');
    return (React.createElement(ContentContainer, { adjustForMediaContent: hasMediaContent },
        React.createElement(TextContent, { adjustForMediaContent: hasMediaContent },
            isFieldValid(answerText) && (React.createElement(RichTextContainer, null,
                React.createElement(RichTextWithAnchor, { field: answerText }))),
            isFieldValid(ctaLink, 'href') && isFieldValid(ctaLinkText) && (React.createElement(CTALink, { field: ctaLink, textField: ctaLinkText, typeField: { value: 'Tertiary' }, isNotTabbable: !allowContentToBeTabbable }))),
        React.createElement(VideoLightbox, { isOpen: isVideoOpen, onClose: () => setIsVideoOpen(false), 
            // TODO: Finalize aria-label approach app-wide
            closeIconLabel: 'Close Lightbox', videoLabel: 'Video', video: video, videoHeight: 70, isContained: false }),
        hasMediaContent && (React.createElement(MediaContainer, null,
            React.createElement(ThumbnailContainer, null, isFieldValid(video, 'href') ? (React.createElement(VideoThumbnail, { media: thumbnailImage, onPlay: onPlay, isNotTabbable: !allowContentToBeTabbable })) : (React.createElement(Image, { field: thumbnailImage })))))));
};
